<template>
  <div class="page-container">
    <v-card>
      <v-card-title>
        <h1>Edit Details</h1>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="userForm"
          v-model="userFormValid"
          lazy-validation
          @submit.prevent="updateUser"
        >
          <v-text-field
            v-model="user.firstname"
            :rules="[rules.required]"
            label="First Name"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.lastname"
            :rules="[rules.required]"
            label="Last Name"
            required
          ></v-text-field>
          <v-text-field
            v-model="user.emailAddress"
            :rules="[rules.required, rules.emailAddress]"
            label="Email Address"
            required
          ></v-text-field>
          <v-btn class="mt-4" type="submit" color="primary">Save</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card class="mt-3">
      <v-card-title>
        <h1>Change Password</h1>
      </v-card-title>
      <v-card-text>
        <v-form
          ref="passwordForm"
          v-model="passwordFormValid"
          lazy-validation
          @submit.prevent="updatePassword"
        >
          <v-text-field
            v-model="password"
            :rules="[rules.required]"
            type="password"
            label="Current Password"
            required
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            :rules="[
              rules.required,
              rules.passwordStrength,
              passwordConfirmationRule()
            ]"
            type="password"
            label="New Password"
            required
          ></v-text-field>
          <v-text-field
            v-model="confirmNewPassword"
            :rules="[
              rules.required,
              rules.passwordStrength,
              passwordConfirmationRule()
            ]"
            type="password"
            label="Confirm New Password"
            required
          ></v-text-field>
          <v-btn class="mt-4" type="submit" color="primary">Save</v-btn>
        </v-form>
      </v-card-text>
    </v-card>

    <snackbar-message
      :snackbar="snackbar"
      :snackbar-text="snackbarText"
      @close="snackbar = false"
    ></snackbar-message>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import SnackbarMessage from '../components/SnackbarMessage.vue'
import Validation from '@/mixins/validation.js'
import objectType from '@/services/Objects.js'

export default {
  name: 'Profile',
  components: {
    SnackbarMessage
  },
  mixins: [Validation],
  data() {
    return {
      userFormValid: true,
      passwordFormValid: true,
      snackbar: false,
      snackbarText: '',
      password: '',
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  computed: {
    user() {
      return Object.assign({}, this.$store.state.user)
    },
    passwordConfirmationRule() {
      return () =>
        this.newPassword === this.confirmNewPassword || 'Password must match'
    }
  },
  watch: {
    newPassword: function() {
      this.$refs.passwordForm.validate()
    },
    confirmNewPassword: function() {
      this.$refs.passwordForm.validate()
    }
  },
  methods: {
    updateUser() {
      if (this.$refs.userForm.validate()) {
        this.$store
          .dispatch('updateUser', {
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            emailAddress: this.user.emailAddress
          })
          .then(() => {
            this.snackbarText = 'Success! - Your user details have been updated'
            this.snackbar = true
          })
      }
    },
    updatePassword() {
      if (this.$refs.passwordForm.validate()) {
        ApiService.post(objectType.User + '/validatepassword', {
          password: this.password
        }).then(({ data }) => {
          if (data) {
            ApiService.post(objectType.User + '/changepassword', {
              password: this.newPassword
            }).then(() => {
              this.snackbarText = 'Success! - Your password has been updated'
              this.snackbar = true
              this.$refs.passwordForm.reset()
            })
          } else {
            this.snackbarText =
              'Failure - Please ensure you have entered your password correctly'
            this.snackbar = true
            this.$refs.passwordForm.reset()
          }
        })
      }
    }
  }
}
</script>

<style scoped></style>
